//export const baseUrl = process.env.REACT_APP_SERVICE_URL;
export const baseUrl = process.env.REACT_APP_SERVICE_URL;
export const baseUmbracoApiUrl = process.env.REACT_APP_UMBRACOAPI_URL;

console.log('baseUrl', baseUrl);
console.log('baseUmbracoApiUrl', baseUmbracoApiUrl);

//export const baseUrl = 'https://sfaapidev.bfgsupply.com';

import { LOCAL_STORAGE_KEYS } from 'src/constants';
export const baseReactSiteUrl = process.env.REACT_APP_BASE_REACT_URL;
export const baseWebApiUrl = process.env.REACT_APP_WEBAPI_SERVICE_URL;

export async function postFile<T>(formdata: FormData, url: string): Promise<T> {
  return new Promise((resolve, reject) => {
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', `${baseUrl}${url}`);
      xhr.withCredentials = true;
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          if (xhr.status === 200) {
            resolve(JSON.parse(xhr.responseText));
          } else {
            reject(xhr.statusText);
          }
        }
      };
      xhr.send(formdata);
    } catch (e) {
      reject(e);
    }
  });
}

export async function postUmbracoFile<T>(formdata: FormData, url: string): Promise<T> {
  return new Promise((resolve, reject) => {
    try {
      var xhr = new XMLHttpRequest();
      //Add Authorizion header

      xhr.open('POST', `${baseUmbracoApiUrl}${url}`);
      //xhr.withCredentials = true;
      xhr.setRequestHeader('Authorization', `Basic ${JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AccessToken))}`);
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          if (xhr.status === 200) {
            resolve(JSON.parse(xhr.responseText));
          } else {
            reject(xhr.statusText);
          }
        }
      };
      xhr.send(formdata);
    } catch (e) {
      reject(e);
    }
  });
}

async function handleResponse<T>(response: Response): Promise<T> {
  return new Promise<any>((resolve, reject) => {
    if (!response.ok) {
      if (response.redirected) {
        var matchUrl: RegExpMatchArray | null = response.url.match(/\/login\/.*$/);
        if (matchUrl) {
          console.log('redirected to login');
          window.location.href = baseReactSiteUrl + '/login/';
        }
      }

      if (response.status === 401) {
        reject(`Unauthorized: status: ${response.status} - ${response.statusText}`);
        return;
      }

      reject(`Error fetching data: status: ${response.status} - ${response.statusText}`);
      return;
    }

    resolve(response.status === 204 ? true : response.json());
  });
}

async function handleBlankResponse(response: Response) {
  return new Promise<void>((resolve, reject) => {
    if (!response.ok) {
      return reject(`Error on fetch call: staus: ${response.status} - ${response.statusText}`);
    }

    resolve();
  });
}

export async function get<T>(endpoint: RequestInfo): Promise<T> {
  const requestOptions: RequestInit = { method: 'GET', credentials: 'include' };
  const response = await fetch(baseUrl + endpoint, requestOptions);
  return handleResponse<T>(response);
}

export async function getUmbraco<T>(endpoint: RequestInfo): Promise<T> {
  const requestOptions: RequestInit = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', Authorization: `Basic ${JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AccessToken))}` },
  };
  const response = await fetch(baseUmbracoApiUrl + endpoint, requestOptions);
  return handleResponse<T>(response);
}

export async function postRaw(endpoint, body: any): Promise<string> {
  return new Promise<string>((resolve) => {
    let xhr = new XMLHttpRequest();
    xhr.open('post', baseUrl + endpoint);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.withCredentials = true;
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        resolve(xhr.responseText);
      }
    };
    xhr.send(JSON.stringify(body));
  });
}

export async function post<T>(endpoint: RequestInfo, body: any): Promise<T> {
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'include',
  };

  const response = await fetch(baseUrl + endpoint, requestOptions);
  return handleResponse<T>(response);
}

export async function postUmbraco<T>(endpoint: RequestInfo, body: any): Promise<T> {
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Basic ${JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AccessToken))}` },
    body: JSON.stringify(body),
  };

  const response = await fetch(baseUmbracoApiUrl + endpoint, requestOptions);
  return handleResponse<T>(response);
}

export async function postWebApi<T>(endpoint: RequestInfo, body: any): Promise<T> {
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json'},
    body: JSON.stringify(body),
    credentials: 'include',
  };

  const response = await fetch(baseWebApiUrl + endpoint, requestOptions);
  return handleResponse<T>(response);
}

export async function postExcelFile<T>(endpoint: RequestInfo, file: File): Promise<T> {
  let formData = new FormData();
  formData.append('file', file, file.name);

  const requestOptions: RequestInit = { method: 'POST', body: formData, credentials: 'include' };
  const response = await fetch(baseUrl + endpoint, requestOptions);

  return handleResponse(response);
}

export async function postExcelFileWithQuery<T>(
  endpoint: string,
  file: File,
  query: Record<string, string | number | boolean>
): Promise<T> {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    params.set(key, String(value));
  });
  const qs = params.toString();
  const url = `${baseUrl}${endpoint}${qs ? `?${qs}` : ''}`;
  const formData = new FormData();
  formData.append('file', file, file.name);
  const response = await fetch(url, { method: 'POST', body: formData, credentials: 'include' });
  return handleResponse<T>(response);
}

export async function put(endpoint: RequestInfo, body: any): Promise<any> {
  const requestOptions: RequestInit = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'include',
  };

  const response = await fetch(baseUrl + endpoint, requestOptions);
  return handleBlankResponse(response);
}

export async function deleteImpl(endpoint: RequestInfo) {
  const requestOptions: RequestInit = { method: 'DELETE', credentials: 'include' };
  const response = await fetch(baseUrl + endpoint, requestOptions);

  return handleBlankResponse(response);
}

export async function deleteUmbraco<T>(endpoint: RequestInfo) {
  const requestOptions: RequestInit = {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', Authorization: `Basic ${JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AccessToken))}` },
  };

  const response = await fetch(baseUmbracoApiUrl + endpoint, requestOptions);
  return handleResponse<T>(response);
}

export default {
  postFile,
  get,
  postRaw,
  post,
  postExcelFile,
  postExcelFileWithQuery,
  postWebApi,
  put,
  delete: deleteImpl,
  getUmbraco,
  postUmbraco,
  postUmbracoFile,
  detletUmbraco: deleteUmbraco,
};
